import React from 'react'
import ReactDOM from 'react-dom'

class KeywordInput extends React.Component{

    constructor(props){
      super(props);
    }

    render(){
      var {keyword, onChange, onClick, isLoading} = this.props;

      return ReactDOM.createPortal(<div>
        <p className="h07_text">Type a keyword below and get real questions that people are asking about it.</p>
        <div className="h07_form_block w-form form-block" >
          <form name="keyword-form" className="keyword-form form">
        <input type="text" className="input w-input" name="keyword" data-name="Keyword" placeholder="How to water a fiddle leaf fig" id="keyword" value={keyword} onChange={onChange} />
        <input type="submit" value={isLoading ? 'Searching...' : 'Get Questions'} data-wait="Please wait..." className="form-button w-button" onClick={onClick} />
        <div className={`hero-form-glow glow-1 ${isLoading ? 'active' : ''}`}></div>
         <div className={`hero-form-glow glow-2 ${isLoading ? 'active' : ''}`}></div>
         <div className={`hero-form-glow glow-3 ${isLoading ? 'active' : ''}`}></div>
         <div className={`hero-form-glow glow-4 ${isLoading ? 'active' : ''}`}></div>
            </form>
        </div></div>, document.getElementById('keyword-input'));
    }

}

export default KeywordInput